const arabicNumbers: Array<string> = [
  "۰",
  "۱",
  "۲",
  "۳",
  "۴",
  "۵",
  "۶",
  "۷",
  "۸",
  "۹",
];

export const separateMoneyNumbers = (str: string) => {
  if (str) {
    const fractions = str.split(".");
    let res = fractions[0]
      .split("")
      .reverse()
      .join("")
      .match(/.{1,3}/g)
      ?.join(",")
      .split("")
      .reverse()
      .join("");
    if (fractions.length > 1) res = res + "." + fractions[1];
    return res;
  }
  return str;
};
export function toFarsiNumberStrict(n?: number | string | null) {
  if (typeof n === "undefined" || n === null) return "";

  const farsiDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

  return n.toString().replace(/\d/g, (x) => farsiDigits[parseInt(x)]);
}
export function toFarsiNumber(n?: number | string | null) {
  if (typeof n === "undefined" || n === null) return "";

  const englishLetters = /^[A-Za-z]$/;
  const persianLetters = /^[\u0600-\u06FF]$/;

  const chars: Array<string> = n.toString().split("");
  let convert = true;
  for (let i: number = 0; i < chars.length; i++) {
    if (englishLetters.test(chars[i])) {
      convert = false; // If an English letter appears, stop conversion
    } else if (persianLetters.test(chars[i])) {
      convert = true; // If a Persian letter or space appears, restart conversion
    }
    if (/\d/.test(chars[i]) && convert) {
      chars[i] = arabicNumbers[Number(chars[i])];
    }
  }

  return chars.join("");
}

export function toEnglishDigits(str?: string) {
  // convert persian digits [۰۱۲۳۴۵۶۷۸۹]
  var e = "۰".charCodeAt(0);
  str = str?.replace(/[۰-۹]/g, (t: string) => {
    return (t.charCodeAt(0) - e) as any;
  });

  // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
  e = "٠".charCodeAt(0);
  str = str?.replace(/[٠-٩]/g, (t: string) => {
    return (t.charCodeAt(0) - e) as any;
  });
  return str;
}

// get correct mobile length
export const getCorrectMobileNumberLength = (mobileNumber: string) =>
  mobileNumber.charAt(0) === "0" ? 11 : 10;

export const checkBeginningMobileNumber = (mobileNumber: string) => {
  const englishMobileNumber = toEnglishDigits(mobileNumber) || "";
  return (
    (englishMobileNumber.length === 1 &&
      englishMobileNumber.charAt(0) === "0") ||
    englishMobileNumber.charAt(0) === "9" ||
    (englishMobileNumber.length > 1 &&
      englishMobileNumber.charAt(0) === "0" &&
      englishMobileNumber.charAt(1) === "9")
  );
};

export const stringifiedFarsiNum = (num: number, alternative: number) => {
  const productsCount = Math.max(alternative, num ?? 0);
  return toFarsiNumber(productsCount.toLocaleString());
};
